import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5a9c41d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "sub-text ion-padding-top" }, " 1. 上傳您的寵物照片(全身、正面、側面、背面等） ", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "**建議照片愈多愈好", -1))
const _hoisted_3 = ["src", "onClick"]
const _hoisted_4 = { class: "ion-padding" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "sub-text" }, " 2. 特徵描述 ", -1))
const _hoisted_6 = { class: "ion-text-center ion-margin-vertical" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" OK! ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_fab_button = _resolveComponent("ion-fab-button")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_textarea = _resolveComponent("ion-textarea")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ion_header, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_toolbar, null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_buttons, { slot: "start" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_button, {
                  slot: "icon-only",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal()))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_icon, { icon: _ctx.arrowBackOutline }, null, 8, ["icon"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ion_title, { class: "ion-text-start" }, {
              default: _withCtx(() => [
                _createTextVNode("您的 " + _toDisplayString(_ctx.petTypeName) + " 特徵備註", 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ion_content, { class: "ion-text-center" }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_grid, { fixed: "" }, {
          default: _withCtx(() => [
            _hoisted_1,
            _hoisted_2,
            _createVNode(_component_ion_grid, { class: "ion-text-center" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_row, null, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.photos, (photo) => {
                      return (_openBlock(), _createBlock(_component_ion_col, {
                        "size-xs": "4",
                        "size-md": "3",
                        "size-xl": "2",
                        key: photo
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_card, { class: "photo-card ion-align-items-center ion-justify-content-center ion-text-center" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_buttons, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_button, {
                                    slot: "icon-only",
                                    onClick: ($event: any) => (_ctx.deletePhoto(photo))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_icon, { icon: _ctx.close }, null, 8, ["icon"])
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"])
                                ]),
                                _: 2
                              }, 1024),
                              _createElementVNode("img", {
                                src: photo.base64Data,
                                onClick: ($event: any) => (_ctx.openImageModal(photo.base64Data))
                              }, null, 8, _hoisted_3)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128)),
                    _createVNode(_component_ion_col, {
                      size: "4",
                      "size-lg": "3",
                      "size-xl": "2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_card, { class: "photo-card ion-align-items-center ion-justify-content-center ion-text-center" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_fab_button, {
                              size: "small",
                              class: "take-photo-fab-btn",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.takePhoto()))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_icon, { icon: _ctx.camera }, null, 8, ["icon"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createVNode(_component_ion_item, { fill: "outline" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_textarea, {
                    "auto-grow": true,
                    modelValue: _ctx.petFeatureRemark,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.petFeatureRemark) = $event)),
                    placeholder: "例子：左眼有黑眼圈、鼻子有白點⋯"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("p", _hoisted_6, [
              _createVNode(_component_ion_button, {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.closeModal(_ctx.petFeatureRemark))),
                class: "info-button",
                size: "large",
                shape: "round"
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}